module.exports = __webpack_public_path__ + "static/media/Background_2.444c1805.svg";